import BaseApi from "@/uptk/core/api/BaseApi";
export const usersApiPath = '/api/users';

export default class UsersApi {

  static getCurrentUserFromServer() {
    return BaseApi.get(`${usersApiPath}/current`)
      .then(
        BaseApi.json
      );
  }

  static getUserStatisticsById(params: any) {
    return BaseApi.get(`${usersApiPath}/statistics/${params.workspaceId}/${params.year}/${params.id}`)
      .then(
        BaseApi.json
      );
  }

  static getUserStatisticsByEmail(params: any) {
    return BaseApi.get(`${usersApiPath}/statistics/${params.workspaceId}/${params.year}/${params.email}`)
      .then(
        BaseApi.json
      );
  }

  static getCurrentUserStatistics(params: any) {
    return BaseApi.get(`${usersApiPath}/current/statistics/${params.workspaceId}/${params.year}`)
        .then(
            BaseApi.json
        );
  }

  static currentUserAcceptedTerms() {
    return BaseApi.post(`${usersApiPath}/current/acceptTerms`, {})
      .then(
        BaseApi.json
      );
  }

  static saveUser(payload: any) {
    return BaseApi.post(`${usersApiPath}`, payload)
        .then(
          BaseApi.json
        );
  }

  static saveUserSelectRole(payload: any) {
    return BaseApi.post(`${usersApiPath}/current/selectrole`, payload)
        .then(
          BaseApi.json
        );
  }

  static assignUserRoles(payload: any) {
    return BaseApi.post(`${usersApiPath}/assign-role`, payload)
        .then(
          BaseApi.json
        );
  }

  static deleteUser(payload: any) {
    return BaseApi.delete(`${usersApiPath}`, payload)
        .then(
          BaseApi.json
        );
  }

  static deactivateUser(id: any) {
    return BaseApi.patch(`${usersApiPath}/${id}/deactivate`, {})
        .then(BaseApi.json);
  }

  static activateUser(id: any) {
    return BaseApi.patch(`${usersApiPath}/${id}/activate`, {})
        .then(BaseApi.json);
  }

  static updateCurrentUserProfile(payload: { firstName?: string; lastName?: string; trigram?: string }) {
    return BaseApi.patch(`${usersApiPath}/current/profile`, payload)
        .then(BaseApi.json);
  }

  static loadUsers(workspaceId: any) {
    
    return BaseApi.get(`${usersApiPath}/`).then(response => {
        return response;
      });
  }

  static loadUser(id: any) {
    return BaseApi.get(`${usersApiPath}/${id}`).then(response => {
        return response;
      })
  }

}
